import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class CjAffiliateCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Archivo', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }
        console.log("in")

        let url = `/api/Merchant/GetCjAffiliateCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "cjCommissionId",
                label: "CJ Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "commissionId",
                label: "Commission ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "cjCommissionCreatedDate",
                label: "Commission Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "id",
                label: "Commission History ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "userId",
                label: "User ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "aid",
                label: "AID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "actionStatus",
                label: "Action Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "actionTrackerId",
                label: "Action Tracker ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "actionType",
                label: "Action Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "actionTrackerName",
                label: "Action Tracker Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "websiteName",
                label: "Website Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "shopperId",
                label: "Shopper ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserId",
                label: "Advertiser ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserName",
                label: "Advertiser Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "postingDate",
                label: "Posting Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "lockingDate",
                label: "Locking Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "pubCommissionAmountUsd",
                label: "Pub Commission Amount (USD)",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "saleAmountPubCurrency",
                label: "Sale Amount (Publisher Currency)",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "saleAmountUsd",
                label: "Sale Amount (USD)",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>;
                    }
                }
            },
            {
                name: "orderId",
                label: "Order ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "coupon",
                label: "Coupon",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => {
                        return <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>;
                    }
                }
            }
        ];


        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Archivo', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default CjAffiliateCommissionData;
